<rid-demo-page [title]="'Dictee'" previousRoute="/mechanics">
  <rid-button class="w-full" content="Dictee | Fysiek" variant="PRIMARY" routerLink="physical" />
  <rid-button class="w-full" content="Dictee | Digitaal" variant="PRIMARY" [disabled]="true" />
</rid-demo-page>
